import { render, staticRenderFns } from "./WidgetsWidget.vue?vue&type=template&id=72895cfd&scoped=true"
import script from "./WidgetsWidget.vue?vue&type=script&lang=js"
export * from "./WidgetsWidget.vue?vue&type=script&lang=js"
import style0 from "./WidgetsWidget.vue?vue&type=style&index=0&id=72895cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72895cfd",
  null
  
)

export default component.exports